import {
  FETCH_PRODUCTS_ERROR,
  FETCH_PRODUCTS_FETCHED,
  FETCH_PRODUCTS_PENDING,
} from '../interfaces/applicationActionTypes';
import { State } from './../interfaces/applicationActionTypes';

const initialState: State = {
  products: {
    pending: false,
    error: '',
    items: [],
  },
};

function applicationReducer(state: State = initialState, action: any) {
  switch (action.type) {
    case FETCH_PRODUCTS_PENDING:
      return { ...state, products: { ...state.products, pending: true } };
    case FETCH_PRODUCTS_FETCHED:
      return { ...state, products: { ...state.products, items: action.payload } };
    case FETCH_PRODUCTS_ERROR:
      return { ...state, products: { ...state.products, error: action.payload } };
    default:
      return state;
  }
}

export default applicationReducer;
